<template>
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="ranking">
        <h3>{{$t('planes_graph_bar_h3')}}</h3>
      </div>
    </div>
    <div class="col-12 col-md-8 pt-3 pb-3">
      <highcharts class="packedbubble" :options="graphOptions"></highcharts>
    </div>
  </div>
</template>

<style lang="scss">
  h4.title-graph {
    font-size: 21px;
    color: #ffffff;
  }
</style>

<script>

  import { Chart } from 'highcharts-vue'
  import Highcharts from "highcharts"
  import more from 'highcharts/highcharts-more'
  import streamgraph from 'highcharts/modules/streamgraph'
  import { map, filter, uniq, sumBy } from 'lodash'

  more(Highcharts)
  streamgraph(Highcharts)

  export default {
    name: 'planesGraphBar',
    props: {
      dataset: Array
    },
    components: {
      highcharts: Chart
    },
    computed: {
      graphOptions() {
        return {
          chart: {
            backgroundColor: 'transparent',
            type: 'column',
            height: 250
          },
          credits: {
            enabled: false
          },
          title: {
              text: ''
          },
          subtitle: {
              text: ''
          },
          xAxis: {
            categories: this.yearsList,
            crosshair: true
          },
          yAxis: {
              min: 0,
              title: {
                  text: 'Cantidad de árboles supervisados'
              }
          },
          legends: {
            color: '#fff'
          },
          tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y}</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
          },
          plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            },
            series: {
              stacking: 'percent',
              ignoreNulls: 'fillSpace'
            }
          },
          series: this.n_data
        }
      },
      yearsList() {
        return uniq(map(this.dataset, item => (item.anio_informe))).sort()
      },
      categories() {
        return [
          { value: "mues_seleccionada_pmf", text: "Árboles supervisados", color: '#2e7832' },
          { value: "individuos_inexistentes", text: "Árboles inexistentes", color: '#b75a5a' }
        ]
      },
      n_data() {
        return map(this.categories, (year) =>  {
          return {
            name: year.text,
            color: year.color,
            data: map(this.yearsList, (n) => {
              return {
                name: n,
                y: sumBy(filter(this.dataset, item => {
                  if(item.anio_informe == n && item[year.value] != 'ND') {
                    return item
                  }
                }), year.value)
              }
            })
          }
        })
      }
    }
  }
</script>